import { ReactComponent as InfoIcon } from '../../assets/arv/info.svg'
import { ReactComponent as EditIcon } from '../../assets/dashboard/edit-contact.svg'

function CardHeader({ title, tooltip }) {
  return (
    <div className="flex items-center justify-center gap-x-[8px]">
      <span className="text-[16px] font-extrabold text-brand-dark">{title}</span>
      {tooltip ? (
        <div className="relative group">
          <InfoIcon className="cursor-default" />
          <div
            className="absolute z-20 hidden group-hover:block bottom-full left-1/2 -translate-x-1/2 mb-[8px] bg-white text-brand-dark rounded-[8px] p-[14px] text-[13px] leading-[1.5] shadow-lg pointer-events-none"
            style={{ width: 315 }}
          >
            {tooltip}
          </div>
        </div>
      ) : (
        <InfoIcon />
      )}
    </div>
  )
}

function ArvEstimateCard({ metrics }) {
  const arv   = metrics?.arv      ?? 0
  const low   = Math.round(arv * 0.96)
  const high  = Math.round(arv * 1.04)

  function fmt(n) {
    if (!n) return ''
    const abs = Math.abs(n)
    if (abs >= 1_000_000) return '$' + (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
    if (abs >= 1_000)     return '$' + Math.round(n / 1_000) + 'K'
    return '$' + n
  }

  return (
    <div className="bg-white border border-[#DCEBD4] rounded-md shadow-card" style={{ width: 300, minHeight: 185, padding: '24px 24px 16px' }}>
      <CardHeader title="ARV Estimate" tooltip="The estimated After-Repair Value derived from adjusted comparable sales. Improve accuracy by removing weaker comps and retaining the most comparable properties." />

      <div className="flex flex-col gap-[2px] items-center mt-[1rem]">
        <div className="flex items-center ">
          <span className="font-extrabold " style={{ fontSize: 28, lineHeight: '32px' }}>
            {arv ? fmt(arv) : ''}
          </span>
        </div>
        { arv ? <span className="text-[12px] text-brand-unselectedGray">Based on adjusted comps</span> : '' }
      </div>

      <div className="mt-[.8rem] px-[0px]">
        { arv ? <div className="h-[8px] rounded-full bg-[linear-gradient(to_right,_#35ce2a,_#1F6F18)] w-full" /> : ''}
        <div className="flex justify-between mt-[4px]">
          <span className="text-[12px] font-bold text-brand-dark">{fmt(low)}</span>
          <span className="text-[12px] font-bold text-brand-dark">{fmt(high)}</span>
        </div>
      </div>
    </div>
  )
}

function CompsStrengthCard({ strength, subtitle }) {
  const label = strength ?? ''
  const sub   = subtitle ?? ''

  return (
    <div className="bg-white rounded-md border border-[#DCEBD4] shadow-card" style={{ width: 300, minHeight: 110, padding: '18px 24px 12px' }}>
      <CardHeader title="Comps Strength" tooltip="Measures how closely the selected comps match the subject property. Higher scores indicate stronger, more relevant comps and greater confidence in the valuation." />
      <div className="flex flex-col items-center mt-[8px]">
        <span className="text-[22px] font-extrabold text-brand-dark">{label}</span>
        <span className="text-[12px] text-brand-unselectedGray">{sub}</span>
      </div>
    </div>
  )
}

function MedianDomCard({ dom }) {
  return (
    <div className="bg-white rounded-md border border-[#DCEBD4] shadow-card" style={{ width: 300, minHeight: 110, padding: '14px 24px 14px', display:'grid', justifyContent:'center' }}>
      <CardHeader title="Median DOM" tooltip="Median Days on Market measures how long comparable properties remained active before selling. Lower values generally indicate stronger demand and a faster-moving market." />
      <div className="flex items-center justify-center mt-[16px]">
        <span className="text-[22px] font-extrabold text-brand-dark">{dom ?? ''}</span>
      </div>
    </div>
  )
}

export default function EstimateMetrics({ metrics }) {
  return (
    <div className="flex flex-col gap-y-[15px]">
      <ArvEstimateCard metrics={metrics} />
      <CompsStrengthCard
        strength={metrics?.strengthLabel ?? null}
        subtitle={metrics?.strengthSub   ?? null}
      />
      <MedianDomCard dom={metrics?.medianDom ?? null} />
    </div>
  )
}
